import { isSamePatient } from '@/utils/helpers';
import { debugConsole } from '@aio/utils';
import * as services from '@services/index';

export enum GENDER {
  Female,
  Male
}

export enum PATIENT_GENDER_DESC {
  '女',
  '男'
}

export interface IPatients {
  id?: number; // 患者ID，更新时需要传
  userId?: number; // 用户快手ID
  patientName: string; // 患者名称
  patientMobile?: string; // 患者手机号
  patientGender: number; // 患者性别，0-女性，1-男性
  patientAge?: number; // 患者年龄
  birthday?: string; // 患者出生日期
  currentCity?: string; // 患者当前所在城市
  patientIdCardNo?: string; // 身份证号 挂号订单才需要
}

interface State {
  preConsultPatient?: Array<IPatients>;
  patientList?: Array<IPatients>;
  lastUpdatePatientId?: number | null;
}

const Patients = {
  state: {
    patientList: [] as Array<IPatients>
  },

  reducers: {
    updateState(state: State, payload: State) {
      return { ...state, ...payload };
    }
  },

  effects: (dispatch) => ({
    async getPatients() {
      try {
        const res = await services.patients.queryPatients();
        this.updateState({
          patientList: res
        });
      } catch (e) {
        // console.log('拉取患者信息错误', e);
      }
    }
  })
};

export default Patients;
